import * as React from "react";
import DeviceContext from "../../../service/indentifyDevice";
import { toINR } from "../../../service/numberFormat";

if (DeviceContext().isDesktop) {
	require("../../../../assets/scss/components/toc/position/positionTopSecContent/positionHeaderDsk.scss");
} else if (DeviceContext().isMobile) {
	require("../../../../assets/scss/components/toc/position/positionTopSecContent/positionHeaderMob.scss");
} else {
	require("../../../../assets/scss/components/toc/position/positionTopSecContent/positionHeaderTab.scss");
}

export interface IPositionTopSecContentProps {
	totalMtm: string;
	totalunrealizedMtm: string;
	totalrealizedMtm: string;
}

const PositionTopSecContent: React.FC<IPositionTopSecContentProps> = props => {
	return (
		<div className="pos_top_sec">
			{/* header content to show MTM values */}
			<div className="summary">
				<p className="mtm_hd">Total MTM</p>
				<h3 className={"mtm_val " + (+props.totalMtm > 0 ? "pos" : +props.totalMtm < 0 ? "neg" : "")}>
					<i className={"val " + (+props.totalMtm > 0 ? "edel-icon-caret-up" : +props.totalMtm < 0 ? "edel-icon-caret-down" : "")}></i>
					<span className="rupy">₹</span>
					{toINR(props.totalMtm, 2)}
				</h3>
				<div className="mtm_row">
					<div className="info info1">
						<p className="txt">Realized MTM</p>
						<p className={"val " + (+props.totalrealizedMtm > 0 ? "pos" : +props.totalrealizedMtm < 0 ? "neg" : "")}>
							<i className={"val " + (+props.totalrealizedMtm > 0 ? "edel-icon-caret-up" : +props.totalrealizedMtm < 0 ? "edel-icon-caret-down" : "")}></i>
							<span className="rupy">₹</span>
							{toINR(props.totalrealizedMtm, 2)}
						</p>
					</div>
					<div className="info info2">
						<p className="txt">Unrealized MTM</p>
						<p className={"val " + (+props.totalunrealizedMtm > 0 ? "pos" : +props.totalunrealizedMtm < 0 ? "neg" : "")}>
							<i className={"val " + (+props.totalunrealizedMtm > 0 ? "edel-icon-caret-up" : +props.totalunrealizedMtm < 0 ? "edel-icon-caret-down" : "")}></i>
							<span className="rupy">₹</span>
							{toINR(props.totalunrealizedMtm, 2)}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PositionTopSecContent;
